
import { useRef } from 'react';

// 

const localRendering = false;
const baseUrl = "https://ar-configurator-3d.herokuapp.com/";
var arPlacement = "floor";

function getMobileOperatingSystem() : 'iOS'|'Android'|'Windows Phone'| 'unknown' {
    const userAgent =
    navigator.userAgent || navigator.vendor || (window as any).opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
        return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
    }

    return 'unknown';
}




export default function ARButton({configuration, setCurrentTab}) {
    var os = getMobileOperatingSystem();

    var iPhone = os === 'iOS';
    var android = os === 'Android';

    var arButton = useRef<HTMLAnchorElement>(null);

    function arButtonClicked()
    {
        if(arButton.current)
            arButton.current.click();
    }

    if(iPhone && localRendering)
    {
        // local rendering

        
        var url = baseUrl + "models/object.usdz"

        return (
            <>
                <button className={' button p-2'}><img height="30px" width="40px" src={baseUrl + 'browsar-icon.png'}></img></button>
                <a ref="ar" className="button" rel="ar" href={url+'?allowsContentScaling=0'}><img height={20} width={20} src="ios.png"/></a>
            </>);
    }
    else if(iPhone && !localRendering)
    {

       // var url = new URL("./models/step.usdz", window.location.href).toString();
        var url = new URL( "/models/step.usdz", baseUrl).toString();

        return (
            <>
                <button className={' button p-2'} onClick={arButtonClicked}><img height="30px" width="40px" src="/browsar-icon.png"></img></button>
                <a className="button is-hidden" rel="ar"
                        ref={arButton}
                        href={url+'?allowsContentScaling=0'}>
                        <img height={20} width={20} src="ios.png"/>
                </a>
            </>);
    }
    else if(android && false)
    {
        const modelUrl = new URL(baseUrl+ "/models/step.gltf");
        const locationUrl = new URL(baseUrl);

        const params = new URLSearchParams(modelUrl.search);


        // modelUrl can contain title/link/sound etc.
        params.set('mode', 'ar_preferred');
        if (!params.has('disable_occlusion')) {
            params.set('disable_occlusion', 'true');
        }
        //if (this.arScale === 'fixed') {
            params.set('resizable', 'false');
        //}
        if (arPlacement === 'wall') {
            params.set('enable_vertical_placement', 'true');
        }
        if (params.has('sound')) {
            const soundUrl = new URL(params.get('sound')!, baseUrl);
            params.set('sound', soundUrl.toString());
        }
        if (params.has('link')) {
            const linkUrl = new URL(params.get('link')!, baseUrl);
            params.set('link', linkUrl.toString());
        }

        const intent = `intent://arvr.google.com/scene-viewer/1.0?${
            params.toString() + '&file=' +
            encodeURIComponent(
                modelUrl
                    .toString())}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${
            encodeURIComponent(locationUrl.toString())};end;`;

        // https://developers.google.com/ar/develop/scene-viewer#ar-only
        // android <a> is 
        

        
        return (
            <>
                <button className="button is-link m-1" disabled>AR binnenkort ook op android</button>
                <a href={intent} 
                    className="button is-hidden"
                    ref={arButton}><img height={20} width={20} src="android.png"/></a>
            </>);
    }
    else {
        return (
            <></>
        );
    }
    
// desktop
// <button className="button is-link m-1" onClick={() => setCurrentTab("qr")}>Bekijk in AR</button>
    
    
    
    

    
    

}